import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "f0c6b94c788077ef7e4870a1104477b02594803f",
});
